const CONSENT_KEY = 'fashin_cookie_consent';

class CookieConsentBanner {
  constructor() {
    this.banner = document.getElementById('cookie-consent-banner');
    if (!this.banner) return;

    const stored = localStorage.getItem(CONSENT_KEY);
    if (stored === null) {
      this.show();
    }

    this.banner.querySelector('[data-cookie-accept]')?.addEventListener('click', () => this.accept());
    this.banner.querySelector('[data-cookie-decline]')?.addEventListener('click', () => this.decline());
  }

  show() {
    this.banner.removeAttribute('hidden');
    requestAnimationFrame(() => requestAnimationFrame(() => this.banner.classList.add('is-visible')));
  }

  hide() {
    this.banner.classList.remove('is-visible');
    this.banner.addEventListener('transitionend', () => this.banner.setAttribute('hidden', ''), { once: true });
  }

  accept() {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    try { window.Shopify?.customerPrivacy?.setTrackingConsent(true, () => {}); } catch (_) {}
    this.hide();
    loadAnalytics();
  }

  decline() {
    localStorage.setItem(CONSENT_KEY, 'declined');
    try { window.Shopify?.customerPrivacy?.setTrackingConsent(false, () => {}); } catch (_) {}
    this.hide();
  }
}

function loadAnalytics() {
  document.dispatchEvent(new CustomEvent('cookie:accepted'));
}

document.addEventListener('DOMContentLoaded', () => new CookieConsentBanner());
